import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import classNames from 'classnames';
import {Modal, Button} from 'react-bootstrap';

import StarRating from 'js/components/star_rating';

require('scss/modals.scss');

export default class BaseModal extends Component {
    static propTypes = {
        title: PropTypes.string,
        altBtnCallback: PropTypes.func,
        altBtnUrl: PropTypes.string,
        altBtnText: PropTypes.string,
        altBtnDownloadName: PropTypes.string,
        showHeader: PropTypes.bool,
        showFooter: PropTypes.bool
    };
    static displayName = 'Base Modal';
    static defaultProps = {
        title: '',
        altBtnCallback: null,
        altBtnUrl: '',
        altBtnText: '',
        altBtnDownloadName: '',
        showHeader: true,
        showFooter: true
    };

    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    close = e => {
        this.setVisiblity(false);
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };

    open = e => {
        this.setVisiblity(true);
    };

    setVisiblity(visibilty) {
        this.setState(
            R.merge(this.state, {
                showModal: visibilty
            })
        );
    }

    show() {
        this.setVisiblity(true);
    }

    hide() {
        this.setVisiblity(false);
    }

    render() {
        const {
            title,
            altBtnCallback,
            altBtnText,
            altBtnUrl,
            altBtnDownloadName,
            showHeader,
            showFooter,
            postUserScore,
            handleClickScore,
            showAvgScore
        } = this.props;
        let altBtn = null;
        if (altBtnCallback) {
            altBtn = (
                <Button className="pull-left" onClick={altBtnCallback}>
                    {altBtnText}
                </Button>
            );
        }
        if (altBtnUrl) {
            altBtn = (
                <div>
                    <a href={altBtnUrl} download={altBtnDownloadName}>
                        <Button onClick={altBtnCallback} className="pull-left">
                            {altBtnText}
                        </Button>
                    </a>
                </div>
            );
        }

        let header = null;
        if (showHeader) {
            header = (
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            );
        }

        const rating = R.hasIn('postUserScore', this.props) ? (
            <StarRating starCount={5} starsFilled={postUserScore} clickScore={handleClickScore}>
                <div className="text-center avg-score">
                    {showAvgScore ? `Avg ${this.props.avg_post_user_score}` : null}
                </div>
            </StarRating>
        ) : null;

        let footer = null;
        const footerClassnames = classNames('row', {
            'post-modal-footer': R.hasIn('postUserScore', this.props)
        });
        if (showFooter) {
            footer = (
                <Modal.Footer>
                    <div className={footerClassnames}>
                        {altBtn}
                        {rating}
                        <Button onClick={this.close} className="pull-right">
                            Close
                        </Button>
                    </div>
                </Modal.Footer>
            );
        }

        return (
            <div className="static-modal base-modal">
                <Modal ref="modal" show={this.state.showModal} onHide={this.close}>
                    {header}

                    <Modal.Body>
                        <div className="modal-content-container">{this.props.children}</div>
                    </Modal.Body>

                    {footer}
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/base_modal.js